import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Typography,
  Box
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import '../style/errorAlert.css';

function ErrorAlert({ open, errorMessage, errorDetail, onClose, logoutOnClose}) {
  return (
    <Dialog
      open={open}
      onClose={(_, reason) => {
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
        onClose();
      }}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          boxShadow: '0 4px 20px rgba(0,0,0,0.15)'
        }
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          backgroundColor: '#f8d7da',
          color: '#721c24',
          borderBottom: '1px solid #f5c6cb',
          py: 0.5,
          px: 2
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <ErrorOutlineIcon />
          <Typography variant="h6" component="span" sx={{ fontWeight: 600 }}>
            Error
          </Typography>
        </Box>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            color: '#721c24',
            '&:hover': {
              backgroundColor: 'rgba(114, 28, 36, 0.1)'
            }
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent className="error-dialog-content">
        <Typography variant="body1" sx={{ color: '#333' }}>
          {errorMessage}
        </Typography>
        {/*  {errorDetail && (
          <Box
            sx={{
              backgroundColor: '#f8f9fa',
              border: '1px solid #dee2e6',
              borderRadius: 1,
              p: 2,
              mt: 2,
              maxHeight: 200,
              overflow: 'auto'
            }}
          >
            <Typography
              variant="body2"
              component="pre"
              sx={{
                fontFamily: 'monospace',
                fontSize: 12,
                color: '#666',
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
                margin: 0
              }}
            >
              {errorDetail}
            </Typography>
          </Box>
        )} */}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 1 }}>
        <Button
          variant="contained"
          onClick={onClose}
          sx={{
            backgroundColor: '#721c24',
            '&:hover': {
              backgroundColor: '#5a161d'
            },
            textTransform: 'none',
            minWidth: 80
          }}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ErrorAlert;
